// Logan日志方法
// 技术文档 https://km.sankuai.com/page/354806436
function getDateNow() {
  const date = new Date();
  return String(date);
}

const logan = {
  // 发送Logan日志
  loganReport() {
    try {
      // 文档：https://km.sankuai.com/page/118270166
      window.Logan && window.Logan.report(null, null);
    } catch (err) {
      console.error(err);
    }
  },
  // Logan Info 日志
  loganCustomFn(...params) {
    // const userInfo = window.__USER_INFO__ || {}; // TODO
    const currentUrl = window.location.href;
    const opt = {
      currentUrl,
      dateNow: getDateNow(),
      // uid: userInfo.id,
      // login: userInfo.login
    };

    logan.loganInfoFn(...params, opt);
  },
  // Logan.info(msg1 || obj1 [, msg2 || obj2, ...])  打info级别的日志
  loganInfoFn(...params) {
    try {
      window.Logan && window.Logan.info(...params);
    } catch (err) {
      console.error(err);
    }
  },
  /**
   * Logan.log(logString, logType, logLevel, tags)  打日志到Logan本地存储
   * @param logString <String> 日志内容，限一次1M。
   * @param logType <String> 可选 默认为'default'。日志类型。已支持'owl'、'redux'、'vuex'、'zaku'、'archer'、'mtgame'、'tracker'、'hotdog'。如需申请新的日志类型，请提TT联系Logan客服。
   * @param logLevel <String> 2.0新增 可选 日志级别，可支持'info'、'warn'、'error'。
   * @param tags <String | String[]> 2.1.0版本及以上 可选 日志标签，可对日志打自定义标签，后续在日志高级查询中可根据标签筛选相关日志
   */
  loganLogFn(...params) {
    try {
      window.Logan && window.Logan.log(...params);
    } catch (err) {
      console.error(err);
    }
  },
  // Logan.warn(msg1 || obj1 [, msg2 || obj2, ...])  打warn级别的日志
  loganWarnFn(...params) {
    try {
      window.Logan && window.Logan.warn(...params);
    } catch (err) {
      console.error(err);
    }
  },
  // Logan.error(msg1 || obj1 [, msg2 || obj2, ...])  打error级别的日志
  loganErrorFn(...params) {
    try {
      window.Logan && window.Logan.error(...params);
    } catch (err) {
      console.error(err);
    }
  },
};
export default logan;
